import { Box, Link, Typography } from '@mui/material';
import React from 'react';

interface FooterLinksProps {
  title: string;
  links: { label: string; href: string }[];
}

const FooterLinks: React.FC<FooterLinksProps> = ({ title, links }) => {
  return (
    <>
      <Typography variant="h6" gutterBottom fontWeight="bold">
        {title}
      </Typography>
      {links.length && (
        <Box display="flex" flexDirection="column" gap={1}>
          {links.map((link, index) => (
            <Link key={index} href={link.href} underline="hover" color="inherit">
              {link.label}
            </Link>
          ))}
        </Box>
      )}
    </>
  );
};

export default FooterLinks;
